import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  panelResizeHandleContainer: {
    width: '1rem',
    alignContent: 'center',
    textAlign: 'center'
  },
  panelResizeHandle: {
    justifySelf: 'center',
    width: '0.5rem',
    height: '100%',
    backgroundColor: 'var(--mui-palette-primary-main)',
    borderRadius: '1rem',
    '&:hover': {
      backgroundColor: 'var(--mui-palette-primary-main)'
    }
  },
  panelResizeHandle2: {
    justifySelf: 'center',
    paddingTop: '.2rem',
    width: '1rem',
    height: '3rem',
    borderRadius: '1rem'
  },
  panelResizeHandle2Inner: {
    width: '.25rem',
    height: '.25rem',
    borderRadius: '.25rem',
    margin: '.35rem',
    backgroundColor: 'var(--mui-palette-background-elevation2)'
  }
}));

export default useStyles;
